import { render, staticRenderFns } from "./DevAxFormFields.vue?vue&type=template&id=06087da2&scoped=true&"
import script from "./DevAxFormFields.vue?vue&type=script&lang=ts&"
export * from "./DevAxFormFields.vue?vue&type=script&lang=ts&"
import style0 from "./DevAxFormFields.vue?vue&type=style&index=0&id=06087da2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06087da2",
  null
  
)

export default component.exports